(() => {
  if (customElements.get('wf-mega-controller')) return;

  class WFMegaController extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = Array.from(this.querySelectorAll('[data-wf-mega-item]'));
      this.overlay = document.querySelector('[data-wf-mega-overlay]');
      this.closeTimer = null;

      this.items.forEach((item) => {
        const toggle = item.querySelector('[data-wf-mega-toggle]');
        const link = item.querySelector('[data-wf-mega-link]');
        item.addEventListener('mouseenter', () => this.scheduleOpen(item));
        item.addEventListener('mouseleave', () => this.scheduleClose(item));
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.scheduleClose(item);
        });
        toggle?.addEventListener('click', () => {
          if (item.classList.contains('is-open')) this.close(item, true);
          else this.open(item);
        });
        link?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.open(item);
            item.querySelector('[data-wf-mega-panel] a')?.focus();
          }
        });
      });

      this.overlay?.addEventListener('pointerdown', this.onOverlayPointerDown);
      this.overlay?.addEventListener('click', this.onOverlayClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      this.overlay?.removeEventListener('pointerdown', this.onOverlayPointerDown);
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      window.clearTimeout(this.closeTimer);
    }

    scheduleOpen(item) {
      window.clearTimeout(this.closeTimer);
      window.setTimeout(() => this.open(item), 60);
    }

    scheduleClose(item) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.close(item), 160);
    }

    open(item) {
      window.clearTimeout(this.closeTimer);
      this.items.forEach((candidate) => {
        if (candidate !== item) this.close(candidate);
      });

      const panel = item.querySelector('[data-wf-mega-panel]');
      const toggle = item.querySelector('[data-wf-mega-toggle]');
      if (!panel || !toggle) return;

      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (this.overlay) this.overlay.style.top = `${panel.getBoundingClientRect().top}px`;
      this.overlay?.removeAttribute('hidden');

      requestAnimationFrame(() => {
        panel.classList.add('is-visible');
        this.overlay?.classList.add('is-visible');
      });
    }

    close(item, restoreFocus = false) {
      const panel = item.querySelector('[data-wf-mega-panel]');
      const toggle = item.querySelector('[data-wf-mega-toggle]');
      if (!panel || !toggle || !item.classList.contains('is-open')) return;

      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-visible');

      window.setTimeout(() => {
        if (!item.classList.contains('is-open')) panel.hidden = true;
      }, 180);

      if (restoreFocus) item.querySelector('[data-wf-mega-link]')?.focus();
      if (!this.items.some((candidate) => candidate.classList.contains('is-open'))) {
        this.overlay?.classList.remove('is-visible');
        window.setTimeout(() => {
          if (!this.items.some((candidate) => candidate.classList.contains('is-open'))) {
            this.overlay?.setAttribute('hidden', '');
          }
        }, 180);
      }
    }

    closeAll(restoreFocus = false) {
      const activeItem = this.items.find((item) => item.classList.contains('is-open'));
      this.items.forEach((item) => this.close(item, false));
      if (restoreFocus) {
        activeItem?.querySelector('[data-wf-mega-link]')?.focus();
      }
    }

    onKeydown = (event) => {
      if (event.key === 'Escape') this.closeAll(true);
    };

    onOverlayPointerDown = () => {
      this.closeAll(false);
    };

    onOverlayClick = () => {
      this.closeAll(false);
    };

    onSectionUnload = (event) => {
      if (event.target.contains(this)) this.closeAll();
    };
  }

  customElements.define('wf-mega-controller', WFMegaController);
})();
